import { styled } from '@mui/material/styles'

type InputProps = {
  spacing: number | string
  backgroundColor?: string
  width?: string | number
  padding?: string | number
  enabled?: boolean
}

export const Spacer = styled('div')<InputProps>(
  ({ theme, spacing, backgroundColor, width, padding, enabled }) => ({
    paddingTop: !padding ? theme.spacing(spacing) : undefined,
    backgroundColor: backgroundColor,
    width: width,
    padding: padding,
    display: enabled === undefined || enabled === true ? 'block' : 'none',
  }),
)
